/**
 * Click-to-edit contract. A dev-only script embedded in project templates posts
 * a message to the parent window when the student clicks an element in the live
 * preview. The builder catches it and includes the reference in the next chat
 * message so the agent knows exactly what the student pointed at.
 */
import { z } from 'zod';
export const CLICK_TO_EDIT_TYPE = 'proteam:click';
export const clickRefSchema = z.object({
    file: z.string(),
    component: z.string(),
    text: z.string(),
});
export const clickToEditMessageSchema = z.object({
    type: z.literal(CLICK_TO_EDIT_TYPE),
    ref: clickRefSchema,
});
/** Type guard for postMessage handlers listening to the preview iframe. */
export function isClickToEditMessage(value) {
    return clickToEditMessageSchema.safeParse(value).success;
}
//# sourceMappingURL=click-to-edit.js.map